import { z } from 'zod';
export const PUBLIC_LABEL_NOTICE_VERSION = 'public-label-unpaid-v1';
export const PUBLIC_LABEL_LOCAL_NOTICE_VERSION = 'public-label-on-device-v1';
export const PUBLIC_LABEL_LOCAL_ASSETS =
  'tesseract-7.0.0-core-7.0.0-eng-tha-1.0.0-best-int-v1:sha256:3af01093db08a1e66039c486a283168c6060d9086581c735d27773ac6de58a00';
export const PUBLIC_LABEL_LOCAL_ASSETS_V2 =
  'tesseract-7.0.0-core-7.0.0-eng-1.0.0-tha-best-e12c65a-float-nonsimd-v2:sha256:48f606cf44f3192e24d49bc62e4ff9fa0850500c91aeec83c2588ad56cb1716c';
export const publicLabelEngineAssetsSchema = z.enum([
  PUBLIC_LABEL_LOCAL_ASSETS,
  PUBLIC_LABEL_LOCAL_ASSETS_V2,
]);
export const PUBLIC_LABEL_LOCAL_NOTICE =
  'ยืนยันว่าภาพตัวอย่างนี้เป็นฉลากสินค้าคู่แข่งที่เผยแพร่สาธารณะ ไม่มีข้อมูลบุคคล ข้อมูลลูกค้า หรือข้อมูลลับ ภาพต้นฉบับและภาพที่เตรียมถูกเก็บในพื้นที่ส่วนตัวของ SQI ตามขั้นตอนอัปโหลด OCR คำนวณบนอุปกรณ์นี้ ไม่ส่งภาพไปยัง Google หรือผู้ให้บริการ OCR ภายนอก ส่งเฉพาะผลข้อความที่มีขนาดจำกัดกลับ SQI เพื่อให้ตรวจแก้ ระบบไม่ได้รับรองว่าทุกพิกเซลเป็นข้อมูลสาธารณะหรือข้อความจากอุปกรณ์ถูกต้อง';
export const PUBLIC_LABEL_NOTICE =
  'ยืนยันว่าภาพตัวอย่างนี้เป็นฉลากสินค้าคู่แข่งที่เผยแพร่สาธารณะ ไม่มีข้อมูลบุคคล ข้อมูลลูกค้า หรือข้อมูลลับ ฉันอนุญาตให้ส่งเฉพาะภาพนี้ไปยังบริการ Google Gemini แบบไม่เสียเงิน ซึ่งอาจใช้ข้อมูลเพื่อปรับปรุงบริการ ระบบไม่ได้รับรองว่าทุกพิกเซลเป็นข้อมูลสาธารณะ';
export const publicLabelOutputSchema = z
  .object({
    rawText: z.string().max(4000),
    uncertainty: z.enum(['unverified', 'unreadable', 'incomplete']),
    warnings: z.array(z.string().max(300)).max(8),
  })
  .strict();
export const publicLabelPrepareSchema = z
  .object({ hash: z.string().regex(/^[a-f0-9]{64}$/), derivativeId: z.uuid() })
  .strict();
export const publicLabelStartSchema = z
  .object({
    preparedId: z.uuid(),
    preparedHash: z.string().regex(/^[a-f0-9]{64}$/),
    noticeVersion: z.enum([PUBLIC_LABEL_NOTICE_VERSION, PUBLIC_LABEL_LOCAL_NOTICE_VERSION]),
    mode: z.enum(['gemini_free', 'software_test', 'tesseract_local']).optional(),
    acknowledged: z.literal(true),
  })
  .strict();
export const publicLabelLocalSubmitSchema = z
  .object({
    preparedHash: z.string().regex(/^[a-f0-9]{64}$/),
    rawText: z.string().max(4000),
    confidence: z.number().min(0).max(100),
  })
  .strict();
export const publicLabelApplySchema = z
  .object({
    correctedOcr: z.string().max(4000),
    quality: z.enum(['readable', 'blurred', 'incomplete']),
    idempotencyKey: z.uuid(),
  })
  .strict();
export const publicLabelRunSchema = z
  .object({
    id: z.uuid(),
    revisionId: z.uuid(),
    revisionHash: z.string(),
    derivativeId: z.uuid(),
    preparedId: z.uuid(),
    preparedHash: z.string(),
    state: z.enum(['pending', 'running', 'completed', 'failed', 'cancelled', 'interrupted']),
    provider: z.enum(['gemini_free', 'software_test', 'tesseract_local']),
    engineAssets: publicLabelEngineAssetsSchema.optional(),
    result: z
      .object({
        output: publicLabelOutputSchema,
        providerVersion: z.string(),
        live: z.boolean(),
        imageHash: z.string(),
        origin: z.literal('client_on_device').optional(),
        provenance: z.literal('client_reported_untrusted').optional(),
        engineAssets: publicLabelEngineAssetsSchema.optional(),
        reportedConfidence: z.number().min(0).max(100).optional(),
      })
      .strict()
      .nullable(),
    appliedRevisionId: z.uuid().nullable(),
  })
  .strict()
  .superRefine((run, context) => {
    if (run.provider === 'tesseract_local' && !run.engineAssets)
      context.addIssue({
        code: 'custom',
        path: ['engineAssets'],
        message: 'Bound local engine required',
      });
    if (
      run.provider === 'tesseract_local' &&
      run.result?.engineAssets !== undefined &&
      run.result.engineAssets !== run.engineAssets
    )
      context.addIssue({
        code: 'custom',
        path: ['engineAssets'],
        message: 'Bound engine mismatch',
      });
  });
export type PublicLabelRun = z.infer<typeof publicLabelRunSchema>;
